/**
 * 组件信息：
 * 用户名片组件（房间外打开）: 1
 * 用户名片组件（房间内打开）: 2
 * ContextMenu组件（房间外打开）: 3
 * ContextMenu组件（房间内打开）: 4
 * 添加好友弹窗: 5
 * 私聊组件（房间成员）: 6
 * 私聊组件（最近聊天）: 7
 * 推荐好友列表: 7
 * 好友关系组件: 8
 * 频道内好友关系组件: 9
 * 语音面板添加所有陌生人: 10
 * 无好友列表组件添加好友: 13
*/
export const ADD_USER_CARD_OUT_ROOM = 1
export const ADD_USER_CARD_IN_ROOM = 2
export const ADD_CONTEXT_MENU_OUT_ROOM = 3
export const ADD_CONTEXT_MENU_IN_ROOM = 4
export const ADD_FRIEND_ADD_DIALOG = 5
export const ADD_IM_ROOM = 6
export const ADD_IM_RECENT = 7
export const ADD_RECOMMEND_FRIEND_LIST = 8
export const ADD_FRIEND_RELATION = 9
export const ADD_VOICE_PANEL_ALL = 10

/**
 * 20号推送的alt_type常量值
 */
export const SOCKET_FRIEND_UPDATE_ALT_TYPE = {
    UPDATE: 0, // 状态改变
    ADD: 1, // 增加
    DELETE: 2, // 删除
}

/**
 * 用户身份类型
 * 陌生人指的是 非互关 非好友
 */
export const USER_IDENTITY_TYPE = {
  STRANGER: 0, // 陌生人
  ME: 1, // 自己
  FRIEND: 2, // 好友
}